
<div class="po-component-container calc-width">
  <div class="ps-5">
    <div class="d-flex pb-3">
      <div class="fw-bold">First Name - </div>
      <div class="ps-1">{{userDetails.givenName}}</div>
    </div>
    <div class="d-flex pb-3">
      <div class="fw-bold">Last Name - </div>
      <div class="ps-1">{{userDetails.familyName}}</div>
    </div>
    <div class="d-flex pb-3">
      <div class="fw-bold">Email - </div>
      <div class="ps-1">{{userDetails.email}}</div>
    </div>
    <div class="d-flex pb-3">
      <div class="fw-bold">Username - </div>
      <div class="ps-1">{{userDetails.preferredUsername}}</div>
    </div>
    <div class="d-flex pb-3">
      <div class="fw-bold">Roles - </div>
      <div class="ps-1">{{roles.join(', ')}}</div>
    </div>
  </div>
</div>
